import { useAppSelector } from '../../../../hooks';
import { ProspectType } from '../../../../types';
import CallContext from './CallContext';
import CustomScenario from './CustomScenario';
import HiddenGems from './HiddenGems';
import Objections from './Objections';
import Priorities from './Priorities';
import Questions from './Questions';

const ScenarioTab = () => {
  const type = useAppSelector((state) => state.prospect.type);

  if (type === ProspectType.CUSTOM) {
    return <CustomScenario />;
  }

  return (
    <div className="flex flex-col gap-4">
      <CallContext />
      <Priorities />
      <Objections />
      <Questions />
      <HiddenGems />
    </div>
  );
};

export default ScenarioTab;
